import { useCallback, useEffect, useRef, useState } from 'react';
import { useFetchQuery } from '../../../__generated__/chirp/com/hubspot/connected/application/status/rpc/frontend/ConnectedStatusGraphQLService.hooks';
const POLL_INTERVAL_MS = 1000;
const POLL_DURATION_MS = 20000;
export function useAppStatus({
  appId,
  shouldFetch = true
}) {
  const numericAppId = typeof appId === 'string' ? parseInt(appId, 10) : appId;
  const isValidAppId = typeof numericAppId === 'number' && !isNaN(numericAppId) && numericAppId > 0;
  const {
    data,
    loading,
    error,
    refetch
  } = useFetchQuery({
    variables: {
      statusFetchOptions: {
        appIds: isValidAppId ? [numericAppId] : []
      }
    },
    skip: !shouldFetch || !isValidAppId
  });
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);
  const [isPolling, setIsPolling] = useState(false);
  const stopPolling = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsPolling(false);
  }, []);
  const pollForStatus = useCallback(() => {
    if (intervalRef.current) {
      // Already polling, do nothing
      return;
    }
    setIsPolling(true);
    intervalRef.current = setInterval(async () => {
      var _refetchData$result;
      const {
        data: refetchData
      } = await refetch();
      const hasOkStatus = refetchData === null || refetchData === void 0 || (_refetchData$result = refetchData.result) === null || _refetchData$result === void 0 || (_refetchData$result = _refetchData$result.results) === null || _refetchData$result === void 0 ? void 0 : _refetchData$result.some(result => result.status === 'Connected');
      if (hasOkStatus) {
        stopPolling();
      }
    }, POLL_INTERVAL_MS);
    timeoutRef.current = setTimeout(stopPolling, POLL_DURATION_MS);
  }, [refetch, stopPolling]);
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  const statusData = data === null || data === void 0 ? void 0 : data.results;
  const hasStatusData = statusData && statusData.length > 0;
  return {
    statusData: hasStatusData ? statusData : undefined,
    statusLoading: loading || isPolling,
    statusError: error,
    pollForStatus
  };
}